<template>
  <div class="listform">
    <div class="form-title">经销商积分记录
      <Icon type="briefcase"></Icon>
      <Button style="margin-left: 30px;" type="primary" @click="GoBack()" icon="md-arrow-back">返回</Button>

    </div>
    <div class="search_option">
      <DatePicker type="daterange" @on-change="DateTimeSelect" :options="dateSearchOption" placement="bottom-end"
        placeholder="根据上传时间筛选" style="width: 200px"></DatePicker>
      <Button type="primary" @click="Search" icon="ios-search">搜索</Button>
      <Button @click="ExportExcel()" type="primary" icon="ios-clipboard">导出</Button>
    </div>

    <div class="radio-group">
      <RadioGroup v-model="currentStatus" @on-change="StatusChange" type="button">
        <Radio label="1">积分记录</Radio>
        <Radio label="2">现金积分记录</Radio>
        <Radio label="3">家装积分记录</Radio>
      </RadioGroup>
    </div>
    <div class="datatable">
      <Table :border="false"  size="small" @on-sort-change="Sort" :columns="table.tablecolumsTitle" :loading="table.loading" :data="table.datalist"></Table>
    </div>
    <div class="footerpage">
      <Page :total="table.total" :page-size="table.pageSize" @on-change="PageChange" :current="table.pageIndex" show-elevator></Page>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      dealerId:0,
      currentStatus: "1",
      queryvalue: "",
      sel_field: "",

      sel_values: [
        { value: "Name", label: "姓名" },
        { value: "Tel", label: "电话" }
      ],
      dateSearchValue: [],
      dateSearchOption: {
        shortcuts: [
          {
            text: "一周内",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              return [start, end];
            }
          },
          {
            text: "一月内",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              return [start, end];
            }
          },
          {
            text: "一年内",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              return [start, end];
            }
          }
        ]
      },
      table: {
        tablecolumsTitle: [
          {
            title: "积分变更数量",
            key: "ChangeIntegralNumber",
            align: "center",
            tooltip: true
          },
          {
            title: "变更类型",
            key: "DataSourceDesc",
            align: "center",
            tooltip: true
          },
          {
            title: "数据来源",
            key: "DataSourceId",
            align: "center",
            tooltip: true,
            render: (h, params) => {
              if(params.row.DataSource==1){
                return h("div", [
                  h(
                    "Button",
                    {
                      props: { type: "primary", size: "small" },
                      style: { marginRight: "10px" },
                      on: {
                        click: () => {
                          this.DataSource(params.row);
                        }
                      }
                    },
                    "关联数据"
                  )
                ]);
              }
            }
          },
          {
            title: "备注",
            key: "Remark",
            align: "center",
            tooltip: true
          },
          {
            title: "变更时间",
            key: "_CreateTime",
            align: "center",
            tooltip: true
          }
        ],
        datalist: [],
        pageIndex: 1,
        total: 0,
        pageSize: 1,
        loading: true,
        sort: " "
      },
      dist_modal: {
        currentdealer: 0,
        show: false,
        distnum: 0
      }
    };
  },
  methods: {
    PageChange: function(e) {
      this.table.pageIndex = e;
      this.GetTableList();
      this.$router.push({
        name: "dealer_childdealerintegrallog",
        params: { dealerid: this.$route.params.dealerid }
      });
    },
    StatusChange: function(e) {
      this.currentStatus = e;
      this.table.pageIndex = 1;
      if (e == "1") {
        this.table.tablecolumsTitle.splice(0, 5);
        this.table.tablecolumsTitle.push(
          {
            title: "积分变更数量",
            key: "ChangeIntegralNumber",
            align: "center",
            tooltip: true
          },
          {
            title: "变更类型",
            key: "DataSourceDesc",
            align: "center",
            tooltip: true
          },
          {
            title: "数据来源",
            key: "DataSourceId",
            align: "center",
            tooltip: true,
            render: (h, params) => {
              if(params.row.DataSource==1){
                return h("div", [
                  h(
                    "Button",
                    {
                      props: { type: "primary", size: "small" },
                      style: { marginRight: "10px" },
                      on: {
                        click: () => {
                          this.DataSource(params.row);
                        }
                      }
                    },
                    "关联数据"
                  )
                ]);
              }
            }
          },
          {
            title: "备注",
            key: "Remark",
            align: "center",
            tooltip: true
          },
          {
            title: "变更时间",
            key: "_CreateTime",
            align: "center",
            tooltip: true
          }
        );
        this.GetTableList();
      } else if (e == "2") {
        this.table.tablecolumsTitle.splice(0, 5);
        this.table.tablecolumsTitle.push(
          {
            title: "积分变更数量",
            key: "ChangeCashIntegral",
            align: "center",
            tooltip: true
          },
          {
            title: "变更类型",
            key: "DataSourceDesc",
            align: "center",
            tooltip: true
          },
          {
            title: "备注",
            key: "Remark",
            align: "center",
            tooltip: true
          },
          {
            title: "变更时间",
            key: "_CreateTime",
            align: "center",
            tooltip: true
          }
        );
        this.GetCashTableList();
      } else if (e == "3") {
        this.table.tablecolumsTitle.splice(0, 5);
        this.table.tablecolumsTitle.push(
          {
            title: "积分变更数量",
            key: "ChangeIntegralNumber",
            align: "center",
            tooltip: true
          },
          {
            title: "变更类型",
            key: "DataSourceDesc",
            align: "center",
            tooltip: true
          },
          {
            title: "备注",
            key: "Remark",
            align: "center",
            tooltip: true
          },
          {
            title: "变更时间",
            key: "_CreateTime",
            align: "center",
            tooltip: true
          }
        );
        this.GetComTableList();
      }
      
    },
    GetTableList: function() {
      var that = this;
      var conditions = [];
      conditions.push({
        PropertyName: "DealerId",
        Operater: 2,
        LogicOperater: 0,
        Value: that.dealerId
      });

      this.$http.SetConditions(conditions);
      that.table.loading = true;
      this.$http
        .get("Dealer/GetIntegral2LogPageList", {
          params: { 
            dealerId:that.dealerId,
            pageIndex: that.table.pageIndex, 
            sort: that.table.sort 
          }
        })
        .then(res => {
          that.table.loading = false;
          res.data.ListData.map(item => {
            item.DataSourceDesc =
              (item.DataSource == 1 && "上传客户档案获得积分") ||
              (item.DataSource == 0 && "手工调整积分") ||
              (item.DataSource == 2 && "水工兑换积分") ||
              "数据异常";
          });
          that.table.datalist = res.data.ListData;
          that.table.total = res.data.TotalCount;
          that.table.pageSize = res.data.PageSize;
        });
    },
    GetCashTableList: function() {
      var conditions = [];
      conditions.push({
        PropertyName: "DealerId",
        Operater: 2,
        LogicOperater: 0,
        Value: this.$route.params.dealerid
      });

      this.$http.SetConditions(conditions);
      var that = this;
      that.table.loading = true;
      this.$http
        .get("Dealer/GetCaIntegralLogPageList", {
          params: {
            dealerId:that.dealerId, 
            pageIndex: that.table.pageIndex, 
            sort: that.table.sort 
            }
        }).then(res => {
          that.table.loading = false;
          res.data.ListData.map(item => {
            item.DataSourceDesc =
              (item.DataSource == 1 && "误工积分消分获得") ||
              (item.DataSource == 0 && "现金积分提货") ||
              "数据异常";
          });
          that.table.datalist = res.data.ListData;
          that.table.total = res.data.TotalCount;
          that.table.pageSize = res.data.PageSize;
        });
    },
    GetComTableList: function() {
      var conditions = [];
      conditions.push({
        PropertyName: "DealerId",
        Operater: 2,
        LogicOperater: 0,
        Value: this.$route.params.dealerid
      });

      this.$http.SetConditions(conditions);
      var that = this;
      that.table.loading = true;
      this.$http
        .get("Dealer/GetCoIntegralLogPageList", {
          params: {
            dealerId:that.dealerId, 
            pageIndex: that.table.pageIndex, 
            sort: that.table.sort 
            }
        }).then(res => {
          that.table.loading = false;
          res.data.ListData.map(item => {
            item.DataSourceDesc =
              (item.DataSource == 1 && "季度带单活动获得") ||
              (item.DataSource == 0 && "家装积分提货") ||
              "数据异常";
          });
          that.table.datalist = res.data.ListData;
          that.table.total = res.data.TotalCount;
          that.table.pageSize = res.data.PageSize;
        });
    },
    Sort: function(sort) {
      if (sort.key != undefined && sort.order != undefined) {
        if (sort.order != "normal") {
          this.table.sort = sort.key + " " + sort.order;
        } else {
          this.table.sort = "";
        }
      }
      this.GetTableList();
    },
    // Search: function(e) {
    //   this.loading = true;
    //   var conditions = [];
    //   if (this.sel_field != "" && this.queryvalue.trim() != "") {
    //     conditions.push({
    //       PropertyName: this.sel_field,
    //       Operater: 0,
    //       LogicOperater: 0,
    //       Value: this.queryvalue.trim()
    //     });
    //   }
    //   this.$http.SetConditions(conditions);
    //   this.GetTableList();
    // },
    DataSource: function(row) {
      if(row.DataSource==1){
        this.$http.SetConditions();
        var conditions = [];
        conditions.push({
          PropertyName: "ID",
          Operater: 2,
          LogicOperater: 0,
          Value: row.DataSourceId
        });
  
        this.$http.SetConditions(conditions);
        this.$router.push({ name: "dealer_customerlist" });
      }else{
        this.$Message.info("无关联数据")
      }
    },
    GoBack: function(e) {
      this.$http.SetConditions();
      this.$router.go(-1);
    },
    Search: function(e) {
      this.loading = true;
      var conditions = [];

      if (this.dateSearchValue != "") {
        if (this.dateSearchValue[0] != "" && this.dateSearchValue[1] != "") {
          if (this.dateSearchValue[0] == this.dateSearchValue[1]) {
            conditions.push({
              PropertyName: "_CreateTime",
              Operater: 2,
              LogicOperater: 0,
              Value: this.dateSearchValue[0]
            });
          } else {
            conditions.push(
              {
                PropertyName: "_CreateTime",
                Operater: 3,
                LogicOperater: 0,
                Value: this.dateSearchValue[0]
              },
              {
                PropertyName: "_CreateTime",
                Operater: 4,
                LogicOperater: 0,
                Value: this.dateSearchValue[1]
              }
            );
          }
        }
      }
      this.$http.SetConditions(conditions);
      this.GetTableList();
    },
    DateTimeSelect: function(e) {
      this.dateSearchValue = e;
    },
    ExportExcel: function() {
      var that = this;
      this.$Spin.show({
        render: h => {
          return h("div", [
            h("Icon", {
              class: "demo-spin-icon-load",
              props: {
                type: "ios-loading",
                size: 18
              }
            }),
            h("div", "生成中..")
          ]);
        }
      });
      that.$http
        .get("Dealer/ExportIntegralLogByDealer", {
          params: {
            dealerId: that.dealerId
          }
        })
        .then(res => {
          that.$Spin.hide();
          window.open(that.$config.fileUrl + res.data);
        });
    },
  },
  created: function() {
    this.dealerId = this.$route.params.dealerid;
    this.GetTableList();
  }
};
</script>
<style>
</style>
 